import React from 'react';
import { Collapse } from '@mantine/core';
import CustomMultiSelect from './CustomMultiSelect';

const FiltersBar = ({
	showFilters = true,
	isLoading = false,
	filterOptions = { region: [], barrio: [], centro: [], empresa: [], area: [] },
	filtersEnabled = {},
	selectedRegions = [],
	selectedBarrios = [],
	selectedCentros = [],
	selectedEmpresas = [],
	selectedAreas = [],
	setSelectedRegions,
	setSelectedBarrios,
	setSelectedCentros,
	setSelectedEmpresas,
	setSelectedAreas,
	filteredCount = 0,
	onClearFilters
}) => {

	const defaultFiltersEnabled = {
		region: true,
		barrio: true,
		centro: true,
		empresa: true,
		area: true
	};

	const finalFiltersEnabled = {
		defaultFiltersEnabled, 
		...filtersEnabled
	}

	return (
		<div className='filters-bar-container'>
			<div className='filters-separator'></div>
			
			<Collapse in={showFilters}>
				<div className='filters-bar-content'>
					<div className='container-fluid'>
						<div className='row align-items-end g-3 filter-group-container'>
							{
								(finalFiltersEnabled.region) ?
									<div className='col-lg col-md-6'>
										<div className='filter-group'>
											<CustomMultiSelect
												data={filterOptions.region}
												value={selectedRegions}
												onChange={setSelectedRegions}
												placeholder="Todas las regiones"
												label="regiones"
												size="xs"
												disabled={isLoading}
											/>
										</div>
									</div> : null
							}
							{
								(finalFiltersEnabled.barrio) ?
									<div className='col-lg col-md-6'>
										<div className='filter-group'>
											<CustomMultiSelect
												data={filterOptions.barrio}
												value={selectedBarrios}
												onChange={setSelectedBarrios}
												placeholder="Todos los barrios"
												label="barrios"
												size="xs"
												disabled={isLoading}
											/>
										</div>
									</div> : null
							}
							{
								(finalFiltersEnabled.area) ?
									<div className='col-lg col-md-6'>
										<div className='filter-group'>
											<CustomMultiSelect
												data={filterOptions.area}
												value={selectedAreas}
												onChange={setSelectedAreas}
												placeholder="Todas las áreas"
												label="áreas"
												size="xs"
												disabled={isLoading}
											/>
										</div>
									</div> : null
							}
							{
								(finalFiltersEnabled.empresa) ?
									<div className='col-lg col-md-6'>
										<div className='filter-group'>
											<CustomMultiSelect
												data={filterOptions.empresa}
												value={selectedEmpresas}
												onChange={setSelectedEmpresas}
												placeholder="Todas las empresas"
												label="empresas"
												size="xs"
												disabled={isLoading}
											/>
										</div>
									</div> : null
							}
							{
								(finalFiltersEnabled.centro) ?
									<div className='col-lg col-md-6'>
										<div className='filter-group'>
											<CustomMultiSelect
												data={filterOptions.centro}
												value={selectedCentros}
												onChange={setSelectedCentros}
												placeholder="Todos los centros"
												label="centros"
												size="xs"
												disabled={isLoading}
											/>
										</div>
									</div> : null
							}
						</div>
					</div>
				</div>
			</Collapse>
		</div>
	);
};

export default FiltersBar;
